import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import './ToggleField.scss';

export const ToggleField = ({ input, toggleOnTheLeft = false }) => {
  const [ defVal, setDefVal ] = useState(input.value);

  useEffect(() => {
    if (input.defaultChecked !== undefined) {
      setDefVal(input.defaultChecked);

      if (!input.notEmitDefaultChecked) {
        input.onChange(input.defaultChecked);
      }
    }
  }, []);

  return (
    <div styleName="toggle-table__inner">
      <div styleName={classNames({ 'toggle-table__col': true, 'toggle-table__col--order-2': toggleOnTheLeft })}>
        <span styleName="toggle-table__label">{input.title}</span>
        <span styleName="toggle-table__note">{input.description}</span>
      </div>
      <div styleName={classNames({ 'toggle-table__col': true, 'toggle-table__col--order-1': toggleOnTheLeft })}>
        <div className="custom-toggle">
          <input type="checkbox" className="custom-toggle__input"
                 id={input.name}
                 name={input.name}
                 checked={input.value === '' ? defVal : input.value}
                 onChange={ev => input.onChange(ev.target.checked)}
          />
          <label htmlFor={input.name} className="custom-toggle__label">
            <span className="custom-toggle__icon" />
          </label>
        </div>
      </div>
    </div>
  );
};
